import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/';
import { User } from 'models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { ILoggedUser } from '../interfaces/loggedUser';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  readonly rootUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  registerUser(user: User): Observable<any> {
    return this.http.post(this.rootUrl + '/api/Users/signup', user);
  }

  private saveToken(data) {
    var localUser = {
      'accessToken': data['access_token'],
      'refresh_token': data['refresh_token'],
      'userName': data['userName'],
      'expires': data['.expires']
    }
    localStorage.setItem('localUser', JSON.stringify(localUser));
  }

  userAuthentication(username, password): Observable<any> {
    var data = 'grant_type=password' + '&username=' + username + '&password=' + password + '&client_id=' + environment.client_id;
    return this.http.post(this.rootUrl + '/oauth/token', data, { headers: new HttpHeaders({ 'Accept-Language': this.translate.getBrowserCultureLang() }) }).pipe(
      tap(data => this.saveToken(data))
    );
  }

  refreshToken(refresh_token): Observable<any> {
    var data = 'grant_type=refresh_token' + '&refresh_token=' + refresh_token + '&client_id=' + environment.client_id;
    var p = this.http.post(this.rootUrl + '/oauth/token', data).pipe(
      tap(data => this.saveToken(data))
    );
    return p;
  }

  getUsers(UserName): Observable<ILoggedUser> {
    return this.http.get<ILoggedUser>(this.rootUrl + '/api/Users/profile?UserName=' + UserName);
  }

  usersUpdate(Id, Nome, Cognome, Telefono): Observable<any> {
    var data = {
      id: Id,
      Nome: Nome,
      Cognome: Cognome,
      Telefono: Telefono
    }
    return this.http.post(this.rootUrl + '/api/Users/update', data);
  }

  usersUpdatePassword(Id, OldPassword, NewPassword): Observable<any> {
    var data = {
      Id: Id,
      NewPassword: NewPassword,
      OldPassword: OldPassword
    }
    return this.http.post(this.rootUrl + '/api/Users/password', data);
  }

  checkmail(username, random, IsWebUser): Observable<any> {
    var data = {
      username: username,
      random: random,
      IsWebUser: IsWebUser
    }
    return this.http.post(this.rootUrl + '/api/Users/checkmail', data);
  }

  forgotPassword(Email, Username): Observable<any> {
    var data = {
      Email: Email,
      Username: Username
    }
    return this.http.post(this.rootUrl + '/api/Users/forgot', data);
  }

  resetPassword(Username, Password, Random, IsWebUser): Observable<any> {
    var data = {
      Username: Username,
      Password: Password,
      Random: Random,
      IsWebUser: IsWebUser
    }
    return this.http.post(this.rootUrl + '/api/Users/reset', data);
  }

  uploadImgProfile(ProfileImg: File, userId: number): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('file', ProfileImg, ProfileImg.name);
    formData.append('userId', userId.toString());
    formData.append('fileName', ProfileImg.name);

    return this.http.post(this.rootUrl + '/api/Users/uploadimgprofile', formData);
  }

  downloadImgProfile(userId: number): Observable<any> {
    return this.http.get(this.rootUrl + '/api/Users/downloadimgprofile', {
      params: {
        userId: userId.toString()
      },
      //responseType: 'text'
    });
  }

  removeImgProfile(userId: number): Observable<any> {
    return this.http.delete(this.rootUrl + '/api/Users/removeimgprofile', {
      params: {
        userId: userId.toString()
      }
    });
  }
}
